import PropTypes from 'prop-types';
import { getLocale } from '!/common/helpers';

const CheckboxItem = props => {
  const { hidden, option, checked, onChange, name } = props;
  return (
    <label className={`${hidden ? 'widget__item-ondemand' : ''} input-checkbox`} >
      <input type="checkbox" value={option.value} checked={checked} onChange={onChange} name={name} />
      <span>
        {getLocale(option.label)}&nbsp;<small>({option.count})</small>
      </span>
    </label>
  );
};
CheckboxItem.protoTypes = {
  hidden: PropTypes.bool,
  option: PropTypes.array.isRequired,
  checked: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  name: PropTypes.string
};
export default CheckboxItem;